import React, { useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import SignIn from '../Auth';
import PrivateRoutes from './PrivateRoutes';
import { getAccessToken, isTokenValid, refreshAccessToken } from "../Utils/auth";
import RegisterWithImageTwo from "../Components/Pages/Others/Authentication/RegisterWithImageTwo";
import ForgetPassword from "../Components/Pages/Others/Authentication/ForgetPassword";
import PricingPlan from "../Pages/PricingPlan";
import PaymentSuccess from "../Pages/paymentSucess";
import TableContractForm from "../Pages/ContractForm";
import PaymentSuccessPage from "../Pages/users/upgradeUser/paymentSuccess";
export default function Routers() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            let token = getAccessToken();

            if (token && isTokenValid(token)) {
                setIsAuthenticated(true);
            } else if (token) {
                const newToken = await refreshAccessToken();
                if (newToken) {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            } else {
                setIsAuthenticated(false);
            }

            setLoading(false);
        };

        checkAuth();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <BrowserRouter basename={'/'}>
            <Routes>
                {isAuthenticated ? (
                    <>
                        <Route path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                        <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                    </>
                ) : (
                    ""
                )}
                <Route path={"/"} element={<PrivateRoutes />}>
                    <Route path={`/*`} element={<LayoutRoutes />} />
                </Route>
                <Route path={`${process.env.PUBLIC_URL}/login`} element={<SignIn />} />
                <Route path={`${process.env.PUBLIC_URL}/trail`} element={<RegisterWithImageTwo />} />
                <Route path={`${process.env.PUBLIC_URL}/auth/forget_password`} element={<ForgetPassword />} />
                <Route path={`${process.env.PUBLIC_URL}/pricing-plan/:id`} element={<PricingPlan />} />

                {/* <Route path={`${process.env.PUBLIC_URL}/data-table/contract-form`} element={<TableContractForm />} /> */}

                <Route path={`${process.env.PUBLIC_URL}/user-upgrade/payment-success/verification/:id`} element={<PaymentSuccessPage />} />
                <Route path={`${process.env.PUBLIC_URL}/payment/:status/:id`} element={<PaymentSuccess />} />
                {/* <Route path={`${process.env.PUBLIC_URL}/payment/failed/:id`} element={<PaymentFailed/>}/> */}
            </Routes>
        </BrowserRouter>
    )
}
